import React from 'react';
import { ForgetPasswordForm } from '../../components/forms';

const ForgotPasswordPage: React.FC = () => {
  return (
    <div className='h-full flex flex-col justify-center w-full max-w-[27.5rem] mx-auto lg:py-12 py-8'>
      <h2 className='!text-4xl !font-medium mb-1 text-secondary-500 lg:text-left text-center'>
        Forgot your password?
      </h2>
      <p className='text-sm mb-6 lg:text-left text-center'>
        Enter your email address to reset your password.
      </p>

      <ForgetPasswordForm />
    </div>
  );
};

export default ForgotPasswordPage;
